import React, { useEffect, useState } from 'react';
import { getServiceAiUsage } from '../../../api/serviceAi';
import { computeServiceAiUsageMeter, usageRingColor } from '../../admin/serviceAi/serviceAiUsageModel';

const tokenFormatter = new Intl.NumberFormat('ja-JP');

// AI利用可能な管理者のときだけ自己利用を取得。失敗時は非表示（ready=false）。
// 送信イベントでも最新化する（グローバルなのでどのページでも追従）。
export function useHeaderAiUsage(enabled) {
  const [state, setState] = useState({ ready: false, meters: null });

  useEffect(() => {
    if (!enabled) {
      setState({ ready: false, meters: null });
      return undefined;
    }
    let cancelled = false;
    const controller = new AbortController();
    const apply = (usage) => {
      if (!cancelled) setState({ ready: true, meters: computeServiceAiUsageMeter(usage) });
    };
    getServiceAiUsage({ signal: controller.signal }).then(apply).catch(() => {
      if (!cancelled) setState({ ready: false, meters: null });
    });
    const onRefresh = () => {
      getServiceAiUsage().then(apply).catch(() => {});
    };
    window.addEventListener('casticart:serviceai-usage-refresh', onRefresh);
    return () => {
      cancelled = true;
      controller.abort();
      window.removeEventListener('casticart:serviceai-usage-refresh', onRefresh);
    };
  }, [enabled]);

  return state;
}

// アバターを今日の利用リングで縁取る。meters が無ければ素通し。
export function HeaderAiAvatarRing({ meters, children }) {
  const today = meters?.today;
  if (!today) return children;
  const style = { '--ring-stroke': '3px' };
  if (!today.unlimited) {
    style['--ring-pct'] = today.usedPct;
    style['--ring-col'] = usageRingColor(today.usedPct);
  }
  return (
    <span className={`header-ai-ring${today.unlimited ? ' is-rainbow' : ''}`} style={style}>
      <span className="header-ai-ring__track" aria-hidden="true" />
      {children}
    </span>
  );
}

function periodValue(meter) {
  return meter.unlimited ? `${tokenFormatter.format(meter.tokens)} tokens` : `残り ${meter.remainingPct}%`;
}

// ドロップダウン内の今日/今月（％のみ。未設定はレインボー＋トークン実数）。
export function HeaderAiUsageMenuRows({ meters }) {
  if (!meters) return null;
  const rows = [
    { key: 'today', label: '今日', meter: meters.today },
    { key: 'month', label: '今月', meter: meters.month },
  ];
  return (
    <div className="user-menu__aiUsage" role="group" aria-label="AIの利用状況">
      {rows.map(({ key, label, meter }) => {
        const style = { '--ring-stroke': '3px' };
        if (!meter.unlimited) {
          style['--ring-pct'] = meter.usedPct;
          style['--ring-col'] = usageRingColor(meter.usedPct);
        }
        return (
          <div className="user-menu__aiUsageRow" key={key}>
            <span className={`header-ai-mini${meter.unlimited ? ' is-rainbow' : ''}`} style={style} aria-hidden="true">
              <span className="header-ai-mini__track" />
            </span>
            <span className="user-menu__aiUsagePeriod">{label}</span>
            <span className="user-menu__aiUsageValue">{periodValue(meter)}</span>
          </div>
        );
      })}
    </div>
  );
}
